import React, { useContext, useEffect, useState } from "react";
import { Context } from "@routes/private/Editor/Context";
import { IProps } from "./types";
import * as S from "./styles";
import ToolBar from "../ToolBar";
import CommandsBars from "../CommandsBars";
import Pickers from "../Pickers";
import Canvas from "../Canvas";
import SwitchSelectDescribe from "../CommandsBars/MainCommandBar/CommandsOptions/SwitchSelectDescribe";
import Zoom from "../InnerToolBar/Zoom";
import DescribedLayerColor from "../DescribedLayerColor";
import SelectDescribe from "../SelectDescribe";
import WarningScreen from "@components/WarningScreen";
import pointerMessage from "assets/pngs/pointerMessage.png";
import { CloseIcon } from "@assets/icons/closeIcon";
import { IPickerGeneralProperties } from "../../types";
import { PermissionEnum } from "@state/designs/types";
import ErrorPage from "@routes/private/ErrorPage";
import InnerToolBar from "../InnerToolBar";
import NoAccess from "../NoAccess";
import { Beforeunload } from "react-beforeunload";
import { isAuthenticated } from "@utils/userAccess";
import { AuthContext } from "@utils/DOIgnition/AuthContext";

const ContentStructure: React.FC<IProps> = (props) => {
  const [showSelectMessage, setShowSelectMessage] = useState(true);
  const [openWarningScreen, setOpenWarningScreen] = useState(false);
  const [warningOptions, setWarningOptions] = useState({
    title: "",
    subtitle: "",
    actionTitle: "",
    actionFunction: undefined,
    closeActionTitle: "",
    errorNote: "",
    errorArguments: [],
  });

  const authContext = useContext(AuthContext);
  const { saveStatus, editorStatus, warningStatus, userPermission } =
    useContext(Context);

  useEffect(() => {
    if (warningStatus !== undefined) {
      setOpenWarningScreen(warningStatus.showWarningScreen);
      setWarningOptions(warningStatus.warningOptions);
    }
  }, [warningStatus]);

  return (
    <Beforeunload
      onBeforeunload={(event) =>
        (saveStatus.savePending ?? false) && event.preventDefault()
      }
    >
      <S.Root>
        {editorStatus.showSelectDescribe ? (
          <>
            <SelectDescribe />
            <S.Row>
              <S.SelectDescribeContainer>
                <SwitchSelectDescribe />
                <InnerToolBar></InnerToolBar>
                <DescribedLayerColor />
              </S.SelectDescribeContainer>
              <S.CanvasContainer>
                <Canvas />
              </S.CanvasContainer>
            </S.Row>
            {showSelectMessage && (
              <S.SelectElement>
                <S.PointerSelectElement>
                  <img src={pointerMessage}></img>
                </S.PointerSelectElement>
                <S.SelectElementMessage>
                  <S.TextMessage>
                    {
                      "Select an element in the layers panel or on the artboard to add it."
                    }
                    <br />
                    <br />
                    {
                      "You can find keyboard shortcuts at the bottom of the page."
                    }
                  </S.TextMessage>
                  <S.CloseMessage onClick={() => setShowSelectMessage(false)}>
                    <CloseIcon />
                  </S.CloseMessage>
                </S.SelectElementMessage>
              </S.SelectElement>
            )}
          </>
        ) : (
          <>
            {userPermission === PermissionEnum.EDIT && <ToolBar />}
            <S.Col
              width={
                userPermission === PermissionEnum.EDIT ? undefined : `100%`
              }
            >
              <CommandsBars />
              {isAuthenticated(authContext.userData) ||
              authContext.userData?.profile?.role === "Staff" ? (
                // (userPermission === PermissionEnum.EDIT || userPermission === PermissionEnum.VIEW) ? (
                <S.Rows>
                  <InnerToolBar />
                  {userPermission === PermissionEnum.EDIT && (
                    <S.PickerContainer
                      right={
                        editorStatus.pickerProperties
                          ? (
                              editorStatus.pickerProperties as IPickerGeneralProperties
                            ).right
                          : false
                      }
                    >
                      <Pickers />
                    </S.PickerContainer>
                  )}
                  <S.CanvasContainer>
                    <Canvas />
                  </S.CanvasContainer>
                </S.Rows>
              ) : (
                // ) : (
                //   <NoAccess />
                // )
                <S.Rows>
                  <S.CanvasContainer>
                    <Canvas />
                  </S.CanvasContainer>
                </S.Rows>
              )}
            </S.Col>
          </>
        )}
        {openWarningScreen && (
          <WarningScreen
            open={openWarningScreen}
            setOpen={setOpenWarningScreen}
            options={warningOptions}
          />
        )}
      </S.Root>
    </Beforeunload>
  );
};

export default ContentStructure;
